import React, {use, useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../config.js';
import { Login } from '../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import Mask from './components/MaskAnimation.js';
//
import Room1 from '../components/rooms/Room1.js'
import Footer from './components/Footer.js';
import '../App.css'
import './rooms.css'
function Component({}) {
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    
    return(
        <div className='bg-white w-full flex flex-col'>
            <Room1/>
            <Footer />
            <Mask />
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)